import { Node } from "@xyflow/react";

import { NodeData } from "../pages/CampaignPage";
import { buildReplySubject } from "./replySubject";
import { stripHtmlToText } from "./stripHtmlToText";

const MAX_ITERATIONS = 100;

const subjectOf = (node: Node<NodeData>, eventBasedState: boolean): string | undefined =>
	eventBasedState ? node.data?.alternateSubject : node.data?.subject;

export const resolveEmailSubject = (
	nodeId: string,
	getPreviousNode: (id: string) => Node<NodeData> | null,
	currentSubject?: string,
	eventBasedState = false
): string => {
	if (currentSubject && currentSubject.trim().length > 0) {
		return currentSubject;
	}

	const visited = new Set<string>();

	let cursor: Node<NodeData> | null = getPreviousNode(nodeId);
	let iterations = 0;

	while (cursor && iterations < MAX_ITERATIONS) {
		if (visited.has(cursor.id)) {
			break;
		}

		visited.add(cursor.id);

		if (cursor.type === "starterNode") {
			break;
		}

		if (cursor.type === "emailNode") {
			const subject = subjectOf(cursor, eventBasedState);

			if (subject && subject.trim().length > 0) {
				return subject;
			}
		}

		cursor = getPreviousNode(cursor.id);
		iterations += 1;
	}

	return "";
};

/**
 * The "Re: …" subject a follow-up email step inherits from the nearest previous
 * email step — what the canvas and editor display (and what the backend sends)
 * as the effective subject. Returns "" when nothing is inheritable.
 */
export const resolveInheritedReplySubject = (
	nodeId: string,
	getPreviousNode: (id: string) => Node<NodeData> | null,
	eventBasedState = false
): string => {
	const inherited = stripHtmlToText(
		resolveEmailSubject(nodeId, getPreviousNode, undefined, eventBasedState)
	);

	return inherited ? buildReplySubject(inherited) : "";
};
